import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import qs from 'query-string';

import { removeTokensLocalStorage } from '../utils/jwt';

function LogoutPage(props) {
  const { location: { search } } = props;
  const url = qs.parse(search);
  const logoutURL = `/login?app_url=${url.app_url}`;
  removeTokensLocalStorage();
  return <Redirect to={logoutURL} />;
}

LogoutPage.propTypes = {
  location: PropTypes.object.isRequired, // supplied from React Router
};

export default LogoutPage;
